import { connect } from 'react-redux';
import React from 'react';
import * as valid from 'utils/validate';
import { renderKBSelect, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { KBFormError,
KBButton } from
'components';
import { MERGE_DEPOSIT } from 'app/constants';
import * as selectors from 'app/selectors';

var SpaceSettingMergeDepositForm = class extends React.Component {constructor(props) {super(props);this.updateSpace = this.updateSpace.bind(this);}updateSpace(

  model) {
    const { updateCurrentSpace } = this.props;
    model.merge_deposit_into_renting =
    model.merge_deposit_into_renting == 'true' ? true : false;
    updateCurrentSpace(
    {
      settings: JSON.stringify({
        subscription_settings: model }) },


    {
      key: 'subscription_settings' });


  }render()
  {
    const {
      fields: { merge_deposit_into_renting },
      error,
      submitting,
      handleSubmit } =
    this.props;
    return (
      <form onSubmit={handleSubmit(this.updateSpace)}>
        <KBFormError err={this.props.error} />
        <div className="kb-form-container" style={{ padding: 0 }}>
          <div className="kb-row">
            <Field name="merge_deposit_into_renting" component={renderKBSelect}
            className="kb-form-group kb-form-c18 kb-form-alone"
            title="租赁方式"

            arrayData={MERGE_DEPOSIT} />

          </div>
          <div className="kb-row m-top">
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              保存
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const setting = props.setting || {};
  const subscriptionSettings = setting.subscription_settings || {};
  let merge_deposit_into_renting =
  subscriptionSettings.merge_deposit_into_renting;

  return {
    initialValues: {
      merge_deposit_into_renting } };


}

const formConfig = {
  form: 'SpaceSettingMergeDepositForm',
  touchOnBlur: false };


const LEGACY_FORM_FIELDS = [
  "merge_deposit_into_renting"
];


export default connect(mapStateToProps)(reduxForm(formConfig)(withReduxFormFieldProps('SpaceSettingMergeDepositForm', LEGACY_FORM_FIELDS)(SpaceSettingMergeDepositForm)));
